
<v-dialog persistent content-class="bg-white p-4 font-lato" v-model="isConfirmShow.isShow" @keydown.esc="closeDialog()" max-width="616">
  <h4 style="font-size: 24px; color: #3F3F3F;" v-html="isConfirmShow.title"></h4>
  <p class="m-0 my-6" style="font-size: 14px; color: #3F3F3F;">
    {{ isConfirmShow.description }}
  </p>
  <slot></slot>
  <div v-if="isConfirmShow.type === 'changes'" class="d-flex justify-content-between align-items-center" style="gap: 8px;">
    <button class="btn btn-outline-primary" @click="closeDialog()">Cancel</button>
    <div class="d-flex justify-content-end align-items-center">
      <button class="btn btn-danger" @click="resetChanges" style="border: none;">Discard</button>
      <button class="btn btn-primary ml-2" @click="saveReport" :disabled="selectedColumns.length === 0">Keep Changes</button>
    </div>
  </div>
  <div v-else-if="isConfirmShow.type === 'update'" class="d-flex justify-content-end align-items-center" style="gap: 8px;">
    <button class="btn btn-outline-primary" @click="closeDialog()">Cancel</button>
    <button class="btn btn-primary" @click="saveReport" :disabled="selectedColumns.length === 0">Update</button>
  </div>
  <div v-else-if="isConfirmShow.type === 'preview'" class="d-flex justify-content-between align-items-center" style="gap: 8px;">
    <button class="btn btn-outline-primary" @click="closeDialog()">Cancel</button>
    <button class="btn btn-primary" @click="updateToPreview" :disabled="selectedColumns.length === 0">Update and Preview</button>
  </div>
  <div v-else-if="isConfirmShow.type === 'run'" class="d-flex justify-content-between align-items-center" style="gap: 8px;">
    <button class="btn btn-outline-primary" @click="closeDialog()">Cancel</button>
    <button class="btn btn-primary" @click="updateToRun" :disabled="selectedColumns.length === 0">Update and Run</button>
  </div>
</v-dialog>
